import React, { useLayoutEffect } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import AboutUs from '../sections/AboutUs'
import Seo from '../components/Seo'
import { sizes } from '../utils/breakpoints'

const SobreNosotros = () => {
  const { t } = useTranslation()

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Container>
      <Seo
        title={t('seo.sobreNosotros.title')}
        description={t('seo.sobreNosotros.description')}
        path="/sobre-nosotros"
      />
      <AboutUs />
    </Container>
  )
}

export default SobreNosotros

const Container = styled.div`
  padding-top: 110px;

  @media (max-width: ${sizes.mobile}px) {
    padding-top: 70px;
  }
`
